const isSchema = obj => obj && obj.__isYupSchema__;
export default isSchema;